import React from 'react'

import { sanitizeHtml } from 'helpers/sanitizeHtml'
import styles from './RichText.module.scss'

interface IRichText {
  data: any
}
const RichText: React.FC<IRichText> = ({ data, children }) => {
  const html = data.content?.toString() || ''

  return (
    <div>
      <>{children}</>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
      />
    </div>
  )
}

export default RichText
